var mask1v2 = "/static/80ad856cd0e8dd52.png";

export { mask1v2 as default };
//# sourceMappingURL=mask-1-v2.png.js.map
